import Card from 'components/Card'
import NormalLayout from 'components/Layouts/NormalLayout'
import { useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { DownloadIcon, ShareIcon, ArrowLeftIcon } from '@heroicons/react/outline'
import ReceiverQRCode from '../../assets/receiver-qr-code.png'

const ReceivePayment = () => {
  const navigate = useNavigate()
  const qrRef = useRef(null)

  const handleSaveQR = () => {
    const link = document.createElement('a')
    link.href = ReceiverQRCode
    link.download = 'ReceiverQRCode.jpg'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <NormalLayout>
      <div className="max-w-md mx-auto">
        <Card>
          <div className="p-6 border-b border-neutral-200">
            <h2 className="text-xl font-semibold text-neutral-800">Receive Payment</h2>
            <p className="text-sm text-neutral-500 mt-1">Share your QR code to receive money</p>
          </div>

          <div className="p-6 flex flex-col items-center">
            <div className="bg-white rounded-2xl border-2 border-neutral-200 p-4 mb-6">
              <img
                className="w-48 h-48 object-contain"
                src={ReceiverQRCode}
                alt="Your QR Code"
                ref={qrRef}
              />
            </div>

            <p className="text-center text-neutral-500 text-sm mb-6">
              Show this QR code to receive payments from anyone
            </p>

            <div className="flex gap-3 w-full mb-6">
              <button
                type="button"
                className="btn-outline btn-md flex-1"
                disabled={true}
              >
                <ShareIcon className="w-5 h-5" />
                Share
              </button>
              <button
                type="button"
                className="btn-primary btn-md flex-1"
                onClick={handleSaveQR}
              >
                <DownloadIcon className="w-5 h-5" />
                Save
              </button>
            </div>

            <button
              onClick={() => navigate('/dashboard')}
              className="flex items-center gap-2 text-sm font-medium text-neutral-600 hover:text-neutral-800 transition-colors"
            >
              <ArrowLeftIcon className="w-4 h-4" />
              Back to Dashboard
            </button>
          </div>
        </Card>
      </div>
    </NormalLayout>
  )
}

export default ReceivePayment
